export enum fiduciaryIdentificationType {
  Cedula = 1,
  Pasaporte = 2,
  RNC = 3,
}
